module.exports = __webpack_public_path__ + "static/media/36-4.5a85a5d8.mp3";